/** JWT payload (claim nomlari backend sozlamalariga qarab farq qilishi mumkin). */
export function readJwtPayload(token: string | null): Record<string, unknown> | null {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function jwtClaimString(
  payload: Record<string, unknown> | null,
  ...keys: string[]
): string | undefined {
  if (!payload) return undefined;
  for (const k of keys) {
    const v = payload[k];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  return undefined;
}

export function jwtTenantId(token: string | null): string | undefined {
  const p = readJwtPayload(token);
  return jwtClaimString(p, 'TenantId', 'tenantId');
}

export function jwtPermissions(token: string | null): string | undefined {
  const p = readJwtPayload(token);
  return jwtClaimString(p, 'Permissions', 'permissions');
}

export function hasAnyPermission(
  token: string | null,
  userRole: string | undefined,
  required: string[],
  fallbackPermissions?: string | null,
): boolean {
  if (!required.length) return true;
  if (userRole === 'Customer') return true;
  const fromJwt = jwtPermissions(token) ?? '';
  const perm = (fromJwt.trim() || (fallbackPermissions ?? '')).trim();
  if (!perm) return false;
  if (perm.toLowerCase() === 'fullaccess') return true;
  const set = new Set(
    perm
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean),
  );
  return required.some((r) => set.has(r.toUpperCase()));
}
